import { Injectable, computed, signal } from '@angular/core';

export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'lms.theme';
const ASSETS_BASE = 'assets';
const LOGO_LIGHT = `${ASSETS_BASE}/logo-lms.png`;
const LOGO_DARK = `${ASSETS_BASE}/logo-lms-light.png`;

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly mode = signal<ThemeMode>('light');
  readonly isDark = computed(() => this.mode() === 'dark');
  readonly logoUrl = computed(() => (this.mode() === 'dark' ? LOGO_DARK : LOGO_LIGHT));

  init(): void {
    const saved = localStorage.getItem(STORAGE_KEY) as ThemeMode | null;
    this.apply(saved === 'dark' ? 'dark' : 'light', false);
  }

  current(): ThemeMode {
    return this.mode();
  }

  toggle(): void {
    this.set(this.mode() === 'dark' ? 'light' : 'dark');
  }

  set(theme: ThemeMode): void {
    this.apply(theme, true);
  }

  private apply(theme: ThemeMode, persist: boolean): void {
    this.mode.set(theme);
    const root = document.documentElement;
    const isDark = theme === 'dark';

    root.classList.toggle('dark', isDark);
    root.dataset['theme'] = theme;
    root.style.colorScheme = theme;

    if (persist) {
      localStorage.setItem(STORAGE_KEY, theme);
    }
  }
}
